import React from 'react';
import {Box, LinearProgress, Typography} from '@mui/material';
import {ownerRowProgress} from './ownerProgressState';
import {isTerminalJobStatus} from './chatJobPolling';

export default function ChatOwnerProgress({progress, status, refreshError}) {
  if (!status) return null;
  const counts = ownerRowProgress(progress);
  const active = !isTerminalJobStatus(status);
  if (!counts && !active) return null;
  const number = (value) => value.toLocaleString();
  return (
    <Box data-testid="owner-search-progress" sx={{mt: 1, width: '100%', overflowWrap: 'anywhere'}}>
      {active && <LinearProgress aria-label="Owner search progress"
        variant={counts ? 'determinate' : 'indeterminate'}
        {...(counts ? {value: (counts.processed_count / counts.total_count) * 100} : {})} />}
      <Typography role="status" variant="body2" sx={{mt: 0.75}}>
        {counts ? `Processed ${number(counts.processed_count)} of ${number(counts.total_count)} companies · Companies with verified contacts: ${number(counts.verified_count)} · Companies not charged: ${number(counts.uncharged_count)}`
          : 'Finding owners…'}
      </Typography>
      {counts?.lookup_charged_count > 0 && <Typography variant="caption" component="p">
        Companies charged for contact provider lookups: {number(counts.lookup_charged_count)}
      </Typography>}
      {counts?.uncharged_owner_count > 0 && <Typography variant="caption" component="p">
        Companies with an identified owner but no verified contact, not charged: {number(counts.uncharged_owner_count)}
      </Typography>}
      {active && <Typography variant="caption" color="text.secondary" component="p">
        {status === 'refund_pending' ? 'Reconciling interrupted owner search.'
          : 'Owner searches can take several minutes. Results appear as each company finishes.'}
      </Typography>}
      {active && refreshError && <Typography variant="caption" color="text.secondary" component="p">{refreshError}</Typography>}
    </Box>
  );
}
